import { api } from './api'
import moment from 'moment';

const initialAuthState = {
  isLoggedIn: false,
  email: '',
  loginError: {}
}

export const auth = {
  state: initialAuthState,
  reducers: {
    handleLoginError(state, payload) {
      if (payload.error) {
        return {
          ...state,
          loginError: {
            non_field_errors: payload.error,
          }
        }
      }
      return {
        ...state,
        loginError: payload
      }
    },
    handleLogout() {
      return initialAuthState
    },
    handleLogin(state, payload) {
      return {
        ...state,
        loginError: {},
        isLoggedIn: true,
      }
    },
    handleWhoAmI(state, payload) {
      return {
        ...state,
        email: payload.email
      }
    },
  },
  effects: (dispatch) => {
    return  {
      async whoAmI() {
        try {
          const res = await api.get('apiauth/v1/whoami/');
          await this.handleWhoAmI(res.data);
          return res.data;
        } catch (e) {
          this.handleLogout();
          return false;
        }
      },
      async startUp() {
        const whoAmIRes = await this.whoAmI();
        if (whoAmIRes.authenticated) {
          this.handleLogin();
        }
      },
      async login(payload, rootState) {
        try {
          await api.post('apiauth/v1/login/', payload);
          this.startUp();
        } catch (e) {
          this.handleLoginError(e.response.data);
        }
      },
      async logout(payload, rootState) {
        await api.get('apiauth/v1/logout/');
        this.handleLogout();
      },
      async resetPassword(payload) {
        try {
          await api.post('apiauth/v1/password_reset/', {email: payload});
          alert("Password reset email has been sent to " + payload + ".");
        } catch (e) {
          this.handleLoginError(e.response.data);
        }
      }
    }
  }
}


export const ticket = {
  state: {
    ticketList: [],
    stripePublishableKey: '',
    clientIntentClientSecret: '',
    showNameChangePaymentDialog: false,
    nameChangePriceStr: 'AUD$5',
    fromName: '',
    toName: '',
    nameChangeTicketDescription: '',
    showChangeSuccessMsg: false,
    showLoadingModal: false,
    ticketTransferData: null,
  },
  reducers: {
    setTicketTransferDataSuccess(state, ticketTransferData) {
      return {
        ...state,
        ticketTransferData,
      }
    },
    getTicketDataSuccess(state, ticketList) {
      return {
        ...state,
        ticketList: ticketList.sort((a, b) => moment(b.event_end_at) - moment(a.event_end_at)),
      }
    },
    updateTicketData(state, ticket) {
      return {
        ...state,
        ticketList: state.ticketList.map(t => {
          if (t.hash === ticket.hash) {
            return ticket
          }
          return t
        }),
      };
    },
    cancelNameChangeReducer(state) {
      return {
        ...state,
        stripePublishableKey: '',
        clientIntentClientSecret: '',
        nameChangePriceStr: 'AUD$5',
        fromName: '',
        toName: '',
        nameChangeTicketDescription: '',
        showNameChangePaymentDialog: false
      }
    },
    toggleLoadingModal(state, payload) {
      return {
        ...state,
        showLoadingModal: payload
      }
    },
    toggleNameChangeSuccessMsg(state, payload) {
      return {
        ...state,
        showChangeSuccessMsg: payload
      }
    },
    enableNameChange(state, payload) {
      return {
        ...state,
        clientIntentClientSecret: payload.stripe_pi_cs,
        stripePublishableKey: payload.stripe_pk,
        nameChangePriceStr: payload.price_str,
        fromName: payload.from_name,
        toName: payload.to_name,
        nameChangeTicketDescription: payload.ticket_description,
        showNameChangePaymentDialog: true
      }
    }
  },
  effects: (dispatch) => {
    return {
      async updateTicket(ticket) {
        this.updateTicketData(ticket);
      },
      async getTicketTransferData(ticketUri) {
        this.toggleLoadingModal(true);
        this.setTicketTransferDataSuccess(null);
        try {
          const res = await api.get(`triniq_ticket/v1/transfer_ticket/${ticketUri}`);
          this.setTicketTransferDataSuccess(res.data);
        } catch (e) {
          alert(
            e.response.data.error
            || 'There was an error processing your request. Please contact us at support@triniq.com'
          );
        }
        this.toggleLoadingModal(false);
      },
      async getTicketData() {
        try {
          const res = await api.get('triniq_ticket/v1/user_event_ticket/')
          this.getTicketDataSuccess(res.data)
        } catch (e) {
          await dispatch.auth.logout()
        }
      },
      async cancelNameChange() {
        this.cancelNameChangeReducer()
      },
      async prepareStripeNameChange(payload) {
        try {
          const res = await api.post(
            'triniq_ticket/v1/prepare_stripe_name_change/',
            {
              hash: payload.hash,
              new_first_name: payload.newFirstName,
              new_last_name: payload.newLastName
            }
          );
          this.enableNameChange(res.data);
        } catch (e) {
          alert("Name change failed. Please contact us at support@triniq.com");
        }
      },
      async closeNameChangeSuccessMsg() {
        this.toggleNameChangeSuccessMsg(false);
      },
      async setLoadingModalVisible() {
        await this.toggleLoadingModal(true);
      },
      async setLoadingModalHide() {
        await this.toggleLoadingModal(false);
      },
      async updateName(payload) {
        try {
          const response = await api.post(
            'triniq_ticket/v1/handle_name_change/',
            {
              paymentId: payload.paymentId,
            }
          );
          await this.cancelNameChangeReducer();
          await this.getTicketData();
          await this.toggleLoadingModal(false);
          await this.toggleNameChangeSuccessMsg(true);
          await this.downloadTicket({
            hash: response.data.hash,
            reference_id: response.data.reference_id
          });
        } catch (e) {
          alert(e.response.data.error)
        }
      },
      async transferTicket(payload) {
        try {
          await this.toggleLoadingModal(true);
          const response = await api.post(
            `triniq_ticket/v2/confirm_transfer_ticket/${payload.ticketTransferUri}`,
            {
              paymentId: payload.paymentId,
              first_name: payload.first_name,
              last_name: payload.last_name,
            }
          );
          await this.toggleLoadingModal(false);
          return response;
        } catch (e) {
          return e.response;
        }
      },
      async downloadTicket(payload) {
        try {
          window.open(
            '/api/triniq_ticket/v1/user_event_ticket/' + payload.hash + '/' + payload.reference_id + '/download',
            '_blank'
          )
        } catch (e) {
          alert("Download ticket failed. Please contact us at support@triniq.com");
        }
      },
      async requestRefund(payload) {
        try {
          await this.toggleLoadingModal(true);
          await api.post(
            'triniq_ticket/v1/user_event_ticket/' + payload.hash + '/' + payload.reference_id + '/request_refund',
            {
              reason: payload.reason,
              other_please_specify: payload.other_please_specify,
            }
          );
          await this.getTicketData();
          await this.toggleLoadingModal(false);
          alert("Refund has been requested.");
        } catch (e) {
          alert("Refund request failed. Please contact us at support@triniq.com");
        }
      },
    }
  }
}
